import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// =====================================================================
// useIsMobile (mobile S91) — detector de tela pequena PADRÃO do app, em
// Material-UI v4 (o app é misto v4+v5; a maioria dos componentes é v4, então
// usamos o theme v4 pra bater com os breakpoints reais deles).
//
// `down('sm')` = < 960px (celular + tablet). Desktop (>= md, 960px) fica
// INTOCADO — todo fix responsivo é gated por este hook, então a experiência
// de desktop não muda. Usar pra: Dialog fullScreen no mobile, empilhar cards,
// esconder/colapsar controles, etc.
// =====================================================================
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}
